import { NavigationEnd, Router } from '@angular/router';

import { AppSettings } from 'pac-api';
import { Component } from '@angular/core';
import { LmsAppSettings } from 'lms-api';
import { PlatformLocation } from '@angular/common';
import { SlideInOutAnimation } from '../animations';
import atatus from 'atatus-spa';
import { routeFadeAnimation } from './animation-route';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeFadeAnimation, SlideInOutAnimation]
})
export class AppComponent {
  title = 'pac-lms';

  constructor(public router: Router, platformLocation: PlatformLocation, private appSettings: AppSettings, private LmsAppSettings: LmsAppSettings) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if (this.LmsAppSettings.Production) {
          gtag('config', 'UA-4945527-3',
            {
              'page_path': platformLocation.pathname
            }
          );
        }
        if (this.LmsAppSettings.CartHeartbeatDisabled) {
          if(atatus) {
            console.warn("Cart heartbeat is disabled");
            atatus.notify(new Error("Cart heartbeat is disabled"));
          } else {
            console.warn("Cart heartbeat is disabled");
          }
        }
      }
    });
  }

  ngOnInit() {
  }
}
